import { render, staticRenderFns } from "./WorkFloEventForm.vue?vue&type=template&id=03e6e9d1&"
import script from "./WorkFloEventForm.vue?vue&type=script&lang=js&"
export * from "./WorkFloEventForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports